/* eslint-disable @typescript-eslint/naming-convention */
import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as ExtensionDetailActions from '../../extension-details/state/extension-detail.actions';
import { GetAccountDetail_account } from '../queries/generated/GetAccountDetail';
import { SaveAccount_account } from '../queries/generated/SaveAccount';
import * as AccountDetailActions from './account-detail.actions';

export const accountDetailFeatureKey = 'accountDetail';

export interface State {
   account: GetAccountDetail_account | null;
   callState: CallState;
}

export const initialState: State = {
   account: null,
   callState: LoadingState.Init,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(AccountDetailActions.accountDetailLoad, AccountDetailActions.accountDetailCancel, (state) => {
      return {
         ...state,
         account: null,
         callState: LoadingState.Loading,
      };
   }),
   on(AccountDetailActions.loadAccountDetailsSuccess, (state, action) => {
      const account: GetAccountDetail_account = action.data;
      return {
         ...state,
         account: {
            ...account,
         },
         callState: LoadingState.Loaded,
      };
   }),
   on(AccountDetailActions.loadAccountDetailsFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(AccountDetailActions.editPresenceCredentialsSubmit, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AccountDetailActions.editPresenceCredentialsSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AccountDetailActions.editPresenceCredentialsFailure, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AccountDetailActions.saveAccountDetailSuccess, (state, action) => {
      const saveAccount: SaveAccount_account = action.data.account;
      const existingAccount: GetAccountDetail_account = <GetAccountDetail_account>state.account;
      return {
         ...state,
         account: {
            accountId: existingAccount.accountId,
            activeEndDate: saveAccount.activeEndDate,
            activeStartDate: saveAccount.activeStartDate,
            callRetentionPolicyTypeId: saveAccount.callRetentionPolicyTypeId,
            createDate: existingAccount.createDate,
            createUser: existingAccount.createUser,
            extensionsConnection: existingAccount.extensionsConnection,
            extensionGroupsConnection: existingAccount.extensionGroupsConnection,
            fileStoreId: existingAccount.fileStoreId,
            holdMusicPrompt: existingAccount.holdMusicPrompt,
            holdMusicPromptId: existingAccount.holdMusicPrompt?.promptId ?? null,
            isInternationalDialingEnabled: saveAccount.isInternationalDialingEnabled,
            isInternationalDialingSuspended: saveAccount.isInternationalDialingSuspended,
            isCallRecordingFeatureEnabled: saveAccount.isCallRecordingFeatureEnabled,
            isRecordInternalCalls: saveAccount.isRecordInternalCalls,
            isRecordInboundCalls: saveAccount.isRecordInboundCalls,
            isRecordOutboundCalls: saveAccount.isRecordOutboundCalls,
            isMailboxMessageTranscriptionEnabled: saveAccount.isMailboxMessageTranscriptionEnabled,
            presenceEnabled: saveAccount.presenceEnabled,
            isResidential: saveAccount.isResidential,
            isSuspended: saveAccount.isSuspended,
            lcsAccountNumber: saveAccount.lcsAccountNumber,
            name: saveAccount.name,
            nameDirectoryPreferenceId: saveAccount.nameDirectoryPreferenceId,
            operatorExtension: existingAccount.operatorExtension,
            operatorExtensionId: existingAccount.operatorExtension?.extensionId ?? null,
            pstnLineLimit: existingAccount.pstnLineLimit,
            shortName: existingAccount.shortName,
            timeZoneId: saveAccount.timeZoneId,
            queueManagementStrategyTypeId: saveAccount.queueManagementStrategyTypeId,
            isAgentCanAssign: saveAccount.isAgentCanAssign,
            updateDate: existingAccount.updateDate,
            updateUser: existingAccount.updateUser,
            isOtrEnabled: saveAccount.isOtrEnabled,
            outboundRecordingNotificationEnabled: existingAccount.outboundRecordingNotificationEnabled,
            defaultAreaCode: saveAccount.defaultAreaCode,
            logLevelId: saveAccount.logLevelId,
            logLevelChangedByUser: saveAccount.logLevelChangedByUser,
            faxFileTypeId: saveAccount.faxFileTypeId,
            isMissedCallsShown: saveAccount.isMissedCallsShown,
            reasonLogLevelChanged: saveAccount.reasonLogLevelChanged,
            logLevelChanged: saveAccount.logLevelChanged,
            isFmFmEnabled: saveAccount.isFmFmEnabled,
            isLcsInternal: saveAccount.isLcsInternal,
            note: existingAccount.note ?? null,
            schedule: existingAccount.schedule ?? null,
            scheduleId: existingAccount.schedule?.scheduleId ?? null,
            presenceUser: existingAccount.presenceUser,
            hasPresenceCredentials: existingAccount.hasPresenceCredentials,
         },
      };
   }),
   on(AccountDetailActions.saveAccountDetail, AccountDetailActions.navigate, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AccountDetailActions.saveAccountDetailFailure, AccountDetailActions.loadAccountAccessDenied, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(ExtensionDetailActions.resetMwiConfirmation, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(
      ExtensionDetailActions.resetMwiSuccess,
      ExtensionDetailActions.resetMwiFailure,
      ExtensionDetailActions.resetMwiCancel,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   )
);
